import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL || "https://scannerspro.duckdns.org/api"}/auth`;


// ajuste conforme sua API backend

// 🔹 Registrar novo usuário
const register = (userData) => {
  return axios.post(`${API_URL}/register`, userData);
};

// 🔹 Login de usuário com salvamento de token
const login = async (userData) => {
  const response = await axios.post(`${API_URL}/login`, userData);

  if (response.data?.token) {
    // salva token no localStorage
    localStorage.setItem("token", response.data.token);

    // salva usuário básico (garantindo formato JSON válido)
    try {
      localStorage.setItem("user", JSON.stringify(response.data.user));
    } catch (error) {
      console.error("Erro ao salvar usuário no localStorage:", error);
      localStorage.removeItem("user");
    }
  }

  return response;
};

// 🔹 Recuperar senha (solicitar link por e-mail)
const forgotPassword = (data) => {
  return axios.post(`${API_URL}/forgot-password`, data);
};

// 🔹 Resetar senha com token
const resetPassword = (token, data) => {
  return axios.post(`${API_URL}/reset-password/${token}`, data);
};

// 🔹 Verificar e-mail
const verifyEmail = (token) => {
  return axios.get(`${API_URL}/verify-email/${token}`);
};

// 🔹 Logout
const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

// 🔹 Obter usuário atual (com tratamento seguro)
const getCurrentUser = () => {
  try {
    const user = localStorage.getItem("user");

    // Se não existir, retorna null
    if (!user) return null;

    // Se o valor não começar com { ou [, limpa e retorna null
    if (user[0] !== "{" && user[0] !== "[") {
      console.warn("Valor inválido detectado no localStorage. Limpando...");
      localStorage.removeItem("user");
      return null;
    }

    return JSON.parse(user);
  } catch (error) {
    console.error("Erro ao ler usuário do localStorage:", error);
    localStorage.removeItem("user");
    return null;
  }
};

// 🔹 Obter token atual
const getToken = () => {
  return localStorage.getItem("token");
};

const authService = {
  register,
  login,
  forgotPassword,
  resetPassword,
  verifyEmail,
  logout,
  getCurrentUser,
  getToken,
};

export default authService;
